module.exports = __webpack_public_path__ + "static/2-87029a1182638da47762847b6e699e92.png";